import React from "react";
import * as Yup from 'yup';
import { CaldaiaDataDto } from "../../generated"
import { MarcaCaldaiaSelectorFree } from "../../marcheCaldaie/components/marcaCaldaiaSelector";

import { Forms } from "../../common/components/CmForms";
const { Form, FormText, FormFloat, ActionBar } = Forms<CaldaiaDataDto>()

interface Props {
    caldaia?: CaldaiaDataDto;
    onSubmit: (caldaia: CaldaiaDataDto) => void;
    onCancel: () => void;
}

export default class CaldaiaForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<CaldaiaDataDto>>({
        marcaCaldaia: Yup
            .string()
            .required('Campo obbligatorio'),
        modelloCaldaia: Yup
            .string()
            .required('Campo obbligatorio'),
        potenzaFocolare: Yup
            .number()
            .min(0)
            .required('Campo obbligatorio'),
        potenzaUtile: Yup
            .number()
            .min(0)
            .required('Campo obbligatorio')

    })

    render() {
        const { caldaia } = this.props;
        if (!caldaia)
            return null;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={caldaia}
                validationSchema={CaldaiaForm.validationSchema}
            >
                {
                    ({ values, set, errors }) =>
                        <div className="card card-outline-info">
                            <div className="card-header text-white">Dati Modello Caldaia</div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <MarcaCaldaiaSelectorFree
                                            onChange={value => set("marcaCaldaia", value ?? undefined)}
                                            value={values.marcaCaldaia ?? null}
                                            label="Marca"
                                            error={errors.marcaCaldaia}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <FormText
                                            name="modelloCaldaia"
                                            label="Modello"
                                        />
                                    </div>
                                    <div className="col-6">
                                        <FormFloat
                                            name="potenzaFocolare"
                                            label="Potenza Focolare"
                                        />
                                    </div>
                                    <div className="col-6">
                                        <FormFloat
                                            name="potenzaUtile"
                                            label="Potenza Utile"
                                        />
                                    </div>
                                </div>
                                <ActionBar
                                    onCancel={this.props.onCancel}
                                />
                            </div>
                        </div>
                }
            </Form>
        );
    }
}
